import { DailyGuest } from '../types';

export function toYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function dateOnlyFromApi(val: string | undefined | null): string {
  if (!val) return '';
  return String(val).trim().slice(0, 10);
}

export function guestStayDays(checkIn: string, checkOut: string): number {
  const a = new Date(dateOnlyFromApi(checkIn));
  const b = new Date(dateOnlyFromApi(checkOut));
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return 1;
  const ms = b.getTime() - a.getTime();
  return Math.max(1, Math.ceil(ms / (1000 * 60 * 60 * 24)));
}

export function guestBalanceDue(g: DailyGuest): number {
  const days = guestStayDays(g.checkInDate, g.checkOutDate);
  const rate = Number(g.dailyRate) || 0;
  const paid = Number(g.amountPaid) || 0;
  const total = Math.round(days * rate * 100) / 100;
  return Math.max(0, Math.round((total - paid) * 100) / 100);
}

export function isActiveDailyGuest(g: DailyGuest): boolean {
  return String(g.status || '').toUpperCase() === 'ACTIVE';
}
